import {getUrlVars, insertValueInUrl, removeParamFromUrl} from '@shared/utils/helpers'

export default {
  helpers: {
    getUrlParam(param) {
      var vars = []
      var href = window.location.href
      var answer_position = href.indexOf('?')
      var hash_position = href.indexOf('#')
      if (answer_position < 0 && hash_position > 0) {
        href = href.replace('#', '?')
        answer_position = hash_position
      }
      if (answer_position > 0 && hash_position > 0) {
        href = href.replace('#', '&')
      }
      var hashes = href.slice(answer_position + 1).split('&')
      for (var i = 0; i < hashes.length; i++) {
        var part = hashes[i].split('=')
        vars.push(part[0])
        vars[part[0]] = part[1]
      }

      return vars[param] || null
    },
    splitByComma(url_value) {
      if (url_value !== 'null') url_value = url_value.split(',')

      return url_value == 'null' ? [] : url_value
    },
  },
  getDateFrom() {
    var date_from = this.helpers.getUrlParam('date_from')
    return date_from == 'null' ? null : date_from
  },
  getDateTo() {
    var date_to = this.helpers.getUrlParam('date_to')
    return date_to == 'null' ? null : date_to
  },

  getGroupBy() {
    return getUrlVars()['group_by'] || 'created_at'
  },
  getSorting() {
    return getUrlVars()['sorting'] || 'null'
  },
  getSortingOrNull() {
    return getUrlVars()['sorting'] || null
  },
  setSorting(sorting) {
    insertValueInUrl('sorting', sorting)
  },
  getSortingColumn() {
    return getUrlVars()['sorting_column'] || 'null'
  },
  getSortBy() {
    return getUrlVars()['sort_by'] || null
  },
  setSortBy(sort_by) {
    insertValueInUrl('sort_by', sort_by)
  },
  getSortingColumnOrNull() {
    return getUrlVars()['sorting_column'] || null
  },
  setSortingColumn(sorting_column) {
    insertValueInUrl('sorting_column', sorting_column)
  },
  setSearchField(search_field) {
    insertValueInUrl('search_field', search_field)
  },
  getSearchField() {
    return getUrlVars()['search_field'] || null
  },
  setSearch(search) {
    insertValueInUrl('q', search)
  },
  getSearch() {
    return getUrlVars()['q'] || null
  },
  setSearchVal(search) {
    insertValueInUrl('search', search)
  },
  getSearchVal() {
    return getUrlVars()['search'] || null
  },
  getGroupByForLevel(level) {
    return this.helpers.getUrlParam('level_' + level + '_group_by')
  },
  setParam(param, value) {
    insertValueInUrl(param, value)
  },
  removeParam(param) {
    removeParamFromUrl(param)
  },
  getParam(param) {
    const value = getUrlVars()[param]
    return value != null ? decodeURIComponent(value) : null
  },
  getGrouping() {
    return getUrlVars()['grouping'] || null
  },
  getDate() {
    return getUrlVars()['date'] || null
  },
  setDate(value) {
    return this.setParam('date', value)
  },
  getTab() {
    return getUrlVars()['tab'] || null
  },
  setTab(value) {
    return this.setParam('tab', value)
  },
  getContactHash() {
    return getUrlVars()['contact_hash'] || null
  },
}
